import { xmlDecl, el } from './index.js';
import { NS } from '../ns.js';

export function generateSettingsXml(): string {
  return (
    xmlDecl() +
    '\n' +
    el(
      'ha:HWPApplicationSetting',
      { 'xmlns:ha': NS.ha },
      '\n' +
      el('ha:CaretPosition', { list: '0', para: '0', pos: '0' }) +
      '\n',
    )
  );
}
